<template>
  <div class="userinfo">
    <header-bar :name='"获奖展示"'></header-bar>
    <div class="info_wrap">
      <div class="comment_wrap" v-if="picData.comment_one">
        <div class="comment_con">
          <img src="../img/m/comment_title.png" alt="" class="comment_title">
          <div class="comment_desc">
            <div class="comment_item">
              {{picData.comment_one}}
            </div>
            <div class="comment_item">
              {{picData.comment_two}}
            </div>
          </div>
        </div>
      </div>
      <div class="altas_info">
        <div class="cover_con">
          <div @click="getPlayAuth()" v-if="!videoShow">
            <div class="cover_bg"></div>
            <img src="../img/m/video_btn.png" alt="" class="video_btn">
            <img :src="'https://collection2021-cos.chineseplus.net/'+picData.video_cover" alt="" class="cover" v-if="Object.keys(picData).length">
          </div>
          <ali-player
          v-if="videoShow"
          :useFlashPrism="false"
          :useH5Prism='true'
          :autoplay="true"
          :isLive="false"
          :rePlay="false"
          :showBuffer="true"
          showBarTime="5000"
          width="100%" 
          height="200px" 
          controlBarVisibility="always"
          :encryptType="1"
          :vid="picData.video_url"
          :playauth="PlayAuth"></ali-player>
        </div>
        <div style="padding:0 .39rem">
          <div class="title">{{picData.title}}</div>
          <div class="author">提供者：{{picData.user_name}}</div>
          <div class="country">所在国：{{picData.cn}}</div>
          <div class="desc">{{picData.desc}}</div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { Notify } from 'vant'
import {mapGetters, mapActions} from 'vuex'
import headerBar from './common/headerBar'
import aliPlayer from './common/aliplayer'
import commonFooter from './common/commonFooter'

export default {
  components: {
    headerBar,
    aliPlayer,
    commonFooter
  },
  data () {
    return {
      picData: {},
      resultShow: false,
      videoShow: false,
      PlayAuth: ''
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.getworkInfo()
  },
  methods: {
    getworkInfo () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.id}).then(res => {
        if (res.code == 1000) {
          this.picData = res.data
        }
      })
    },
    getPlayAuth () {
      this.$utils.get('/works/getPlayAuth', {video_id: this.picData.video_url}).then(res => {
        if (res.code == 1000) {
          this.PlayAuth = res.data.PlayAuth
          this.videoShow = true
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .info_wrap {
    padding: .28rem .44rem 0rem;
    .comment_wrap {
      // padding: 0 .45rem;
      margin-bottom: .3rem;
      .comment_con {
        background-color: #ffffff;
        position: relative;
        padding: 1.4rem .5rem .6rem;
        margin-top: .8rem;
        .comment_title {
          position: absolute;
          width: 7.44rem;
          display: block;
          left: 50%;
          top: -.48rem;
          margin-left: -3.72rem;
        }
        .comment_desc {
          font-size: .35rem;
          line-height: 1.4;
          .comment_item {
            margin-bottom: .3rem;
          }
        }
      }
      
    }
    .altas_info {
      background: #fff;
      height: calc(100vh - 3rem);
      .cover_con {
        position: relative;
        .cover_bg {
          background-color: rgba(0,0,0,.3);
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .video_btn {
          width: 1.21rem;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .cover {
          width: 100%;
        }
      }

      .title {
        font-size: .8rem;
        color: #282828;
        margin-top: .6rem;
        margin-bottom: .7rem;
      }
      .author {
        font-size: .48rem;
        color: #666;
      }
      .country {
        font-size: .48rem;
        color: #666;
        margin-top: .15rem;
      }
      .desc {
        font-size: .48rem;
        color: #666;
        margin-top: .3rem;
        line-height: 1.4;
        padding-bottom: .5rem;
      }
    }
  }
  .bottom_con {
    position: fixed;
    bottom: 0;
    width: 100%;
    .result {
      background-color: #f64109;
      position: relative;
      text-align: center;
      padding-top: 1.28rem;
      padding-bottom: .9rem;
      .refresh {
        position: absolute;
        right: .6rem;
        top: .45rem;
        width: .8rem;
      }
      .plus {
        img {
          width: 1.2rem;
          vertical-align: middle;
          margin-right: .2rem;
        }
        span {
          font-size: 1.34rem;
          color: #fff;
          vertical-align: middle;
        }
      }
      .tip {
        font-size: .48rem;
        color: rgba(255,255,255,.6);
        margin-top: 1.26rem;
      }
    }
    .vote_con {
      height: 2.38rem;
      .num_con {
        float: left;
        height: 2.38rem;
        width: calc(100% - 5.3rem);
        line-height: 2.3rem;
        background-color: #000000;
        img {
          width: 1.2rem;
          margin-right: .6rem;
          margin-left: .5rem;
        }
        .num {
          font-size: 1.34rem;
          color: #fff;
        }
      }
      .vote_btn {
        float: right;
        height: 2.38rem;
        background-color: #f64109;
        font-size: .8rem;
        color: #fff;
        text-align: center;
        line-height: 2.3rem;
        width: 5.3rem;
      }
    }
  }
}
</style>
